// extracted by mini-css-extract-plugin
module.exports = {"button":"button-346e9355","green":"green-fb54e20a","blue":"blue-318dafd4","small":"small-df5a1831","label":"label-85dbd66f"};